// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"bbbbcd29","199":"1f1e8efc","211":"b3dc2340","485":"9aabb531","683":"0c224960","740":"c52989e2"}[chunkId] + ".chunk.js";
};